module.exports = (__webpack_require__(49129))(8567);